<template>
  <div class="note-warp">
    <div class="note-book">
      <div class="title">
        <span class="fade-in fade-in-anim">{{ $t("title") }}</span>
      </div>
      <div class="note-box">
        <template v-if="audioDuration">
          <div>
            <div class="note-title" ref="phone">
              {{ $t("toPhone", { phone: content.recipientPhone }) }}
            </div>
            <div class="time">
              <div class="time-box" ref="time">
                {{ showTime(content.createTime) }}
              </div>
            </div>
            <!-- <div class="cntr" ref="cntr"></div> -->
            <div class="voice-box">
              <div class="voice-header" @click="toggleAudio">
                <div ref="lottieAnimation" class="voice-img"></div>
                <!-- <img
                src="@/assets/voice.svg"
                alt="voice"
                class="voice-img"
              /> -->
                <span>{{ formatDuration(showDuration) }}</span>
              </div>
              <div class="voice-txt" v-if="showVoiceTxt">
                {{ content.message }}
              </div>
            </div>
            <div class="show-text" @click="showVoiceTxt = !showVoiceTxt">
              {{ showVoiceTxt ? $t("closeVoice") : $t("showVoice") }}
            </div>
          </div>
          <a
            class="link-box"
            target="_blank"
            rel="noopener noreferrer"
            :href="content.domain"
            v-if="content.domain"
            >{{ showDomain(content.domain) }}</a
          >
        </template>
      </div>
      <audio
        ref="audioPlayer"
        class="audio"
        @ended="onAudioEnded"
        @timeupdate="updateCurrentTime"
        :src="content.url"
      ></audio>
    </div>
  </div>
</template>

<script>
import TypeIt from "typeit";
import { getMessageCode } from "@/api/index";
import dayjs from "dayjs";
import lottie from "lottie-web";
import animation from "@/assets/animation.json";
export default {
  name: "index-warp",
  data() {
    return {
      isPlaying: false,
      animation: null,
      audioDuration: null,
      showVoiceTxt: false,
      currentTime: 0,
      content: {
        phone: "",
        content: "",
        time: "",
      },
    };
  },
  mounted() {
    this.init(this.$route.params.order);
  },
  computed: {
    showDuration() {
      return this.audioDuration - this.currentTime;
    },
  },
  methods: {
    showDomain(domain) {
      if (!domain) {
        return;
      }
      return domain.replace(/^https?:\/\//, "");
    },
    showAnimation() {
      this.animation = lottie.loadAnimation({
        container: this.$refs.lottieAnimation,
        loop: true,
        renderer: "svg",
        autoplay: false,
        animationData: animation, // Path to your Lottie animation JSON file
      });
      this.resetAnimation();
    },
    updateCurrentTime() {
      this.currentTime = this.$refs.audioPlayer.currentTime; // 更新当前播放时间
    },
    togglePlayback() {
      if (this.isPlaying) {
        this.animation.play();
      } else {
        this.resetAnimation();
      }
    },
    resetAnimation() {
      this.animation.stop();
      this.animation.goToAndStop(12, true); // 跳转到最后一帧并停止
    },
    onAudioEnded() {
      this.isPlaying = false; // Reset playback state
      this.resetAnimation();
      this.$nextTick(() => {
        this.currentTime = 0;
      });
    },
    getAudioDuration() {
      const audioPlayer = this.$refs.audioPlayer;
      if (!isNaN(audioPlayer.duration)) {
        this.audioDuration = audioPlayer.duration; // Get duration in seconds
        this.$nextTick(() => {
          this.showAnimation();
        });
      }
    },
    showTime(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    formatDuration(totalSeconds) {
      if (!totalSeconds) {
        return "";
      }
      let hours = Math.floor(totalSeconds / 3600);
      let minutes = Math.floor((totalSeconds % 3600) / 60);
      let seconds = Math.floor(totalSeconds % 60);
      // Add leading zeroes if needed
      if (hours > 0) {
        hours = String(hours).padStart(2, "0");
        hours = `${hours}:`;
      } else {
        hours = "";
      }
      if (hours > 0 || minutes > 0) {
        minutes = String(minutes).padStart(2, "0");
        minutes = `${minutes}:`;
      } else {
        minutes = "";
      }
      if (Number(seconds) === 0 && !this.isPlaying) {
        seconds = 1;
      }
      if ((!hours || hours === 0) && (!minutes || minutes === 0)) {
        seconds = `${seconds}s`;
      }
      return `${hours}${minutes}${seconds}`;
    },
    toggleAudio() {
      const audioPlayer = this.$refs.audioPlayer;
      if (this.isPlaying) {
        audioPlayer.pause();
      } else {
        audioPlayer.play();
      }
      audioPlayer.currentTime = 0; // 重置播放时间为0
      this.isPlaying = !this.isPlaying;
      this.togglePlayback();
    },
    getTypeIt($el, text, speed = 5) {
      return new Promise((resolve) => {
        new TypeIt($el, {
          strings: text,
          cursorChar: "", //用于光标的字符。HTML也可以
          speed: speed,
          lifeLike: true, // 使打字速度不规则
          cursor: true, //在字符串末尾显示闪烁的光标
          breakLines: false, // 控制是将多个字符串打印在彼此之上，还是删除这些字符串并相互替换
          loop: false, //是否循环
        })
          .exec(async () => {
            return resolve();
          })
          .go();
      });
    },
    async init(code) {
      if (!code) {
        return;
      }
      const { obj } = await getMessageCode(code);
      this.content = obj;
      const audio = this.$refs.audioPlayer;
      audio.ondurationchange = () => {
        this.getAudioDuration();
      };
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.fade-in {
  opacity: 0;
}

/* Define the animation */
@keyframes fadeInAnimation {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

/* Apply the animation to the text with a duration and timing function */
.fade-in-anim {
  animation: fadeInAnimation 0.5s ease-in-out forwards;
}
.audio {
  position: fixed;
  left: -9999;
  width: 1px;
  height: 1px;
  opacity: 0;
}
@media only screen and (min-width: 751px) {
  .note-warp {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
    .note-book {
      width: 500px;
      margin: 0 auto;
      border-radius: 4px;
      border-radius: 32px;
      background: #fff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.2);
      .note-box {
        padding: 0px 40px;
        min-height: 60vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .link-box {
          text-align: center;
          text-decoration: none;
          color: #4089ff;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          padding-bottom: 11px;
        }
        .voice-box {
          border-radius: 5px;
          background: #f7f7f7;
          padding: 8.5px 17px;
          .voice-header {
            display: flex;
            align-items: center;
            font-size: 15px;
            color: #000;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            .voice-img {
              width: 17px;
              height: 28px;
              margin-right: 8px;
            }
          }
          .voice-txt {
            border-top: 1px solid rgba(#ddd, 0.5);
            color: #000;
            font-size: 10px;
            font-style: normal;
            font-weight: 400;
            line-height: normal;
            padding: 5px 0;
            margin-top: 8px;
          }
        }
        .show-text {
          padding-top: 12px;
          color: #4089ff;
          font-size: 15px;
          display: flex;
          justify-content: flex-end;
          cursor: pointer;
          .time-box {
            height: 24px;
            line-height: 24px;
            text-align: right;
          }
        }
        .note-title {
          padding: 40px 0;
          line-height: normal;
          color: rgba(0, 0, 0, 0.8);
          font-size: 17px;
          font-style: normal;
          font-weight: 400;
          padding-bottom: 32px;
          line-height: normal;
          font-weight: bold;
        }
      }
      .title {
        width: 100%;
        padding: 20px 0;
        text-align: center;
        color: #fff;
        font-size: 23px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        background: #ffc745;
        border-radius: 32px 32px 0 0;
      }
      .cntr {
        /* 实现横线效果 */
        background: linear-gradient(transparent 98%, #e2e2e2 0);
        line-height: 30px;
        background-size: 100% 30px;
        background-attachment: local;
        resize: none;
        font-size: 14px;
        outline: none;
        border: none;
        overflow-x: hidden;
        min-height: 400px;
        color: rgba(0, 0, 0, 0.8);
        font-family: system-ui;
        font-size: 15px;
        font-style: normal;
        padding-bottom: 60px;
        padding: 0 10px;
        font-weight: 400;
        border-top: none;
      }
      .time {
        color: #565656;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 8px;
        .time-box {
          height: 24px;
          line-height: 24px;
          text-align: left;
        }
      }
    }
  }
}
@media only screen and (max-width: 750px) {
  .note-warp {
    padding: 25px 0;
    width: 100%;
    .note-book {
      width: 94%;
      margin: 0 auto;
      border-radius: 32px;
      background: #fff;
      box-shadow: 0px 4px 32px 0px rgba(0, 0, 0, 0.2);
      .note-box {
        padding: 0px 20px;
        min-height: 80vh;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .link-box {
          text-align: center;
          text-decoration: none;
          color: #4089ff;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          padding-bottom: 11px;
        }
        .note-title {
          padding: 30px 0;
          padding-bottom: 20px;
          line-height: normal;
          color: rgba(0, 0, 0, 0.8);
          font-size: 17px;
          font-style: normal;
          font-weight: 400;
          font-weight: bold;
        }
      }
      .title {
        width: 100%;
        padding: 20px 0;
        text-align: center;
        color: #fff;
        font-size: 26px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        background: #ffc745;
        border-radius: 16px 16px 0 0;
      }
      .cntr {
        /* 实现横线效果 */
        background: linear-gradient(transparent 98%, #e2e2e2 0);
        line-height: 40px;
        background-size: 100% 40px;
        background-attachment: local;
        resize: none;
        font-size: 16px;
        outline: none;
        border: none;
        overflow-x: hidden;
        min-height: calc(60vh - 20px);
        color: rgba(0, 0, 0, 0.8);
        font-family: system-ui;
        font-size: 15px;
        font-style: normal;
        font-weight: 400;
        padding: 0px 10px;
        padding-bottom: 60px;
      }
      .voice-box {
        border-radius: 5px;
        background: #f7f7f7;
        padding: 8.5px 17px;
        .voice-header {
          display: flex;
          align-items: center;
          font-size: 15px;
          color: #000;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          .voice-img {
            width: 17px;
            height: 28px;
            margin-right: 8px;
          }
        }
        .voice-txt {
          border-top: 1px solid rgba(#ddd, 0.5);
          color: rgba(0, 0, 0, 0.86);
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          line-height: 21px;
          padding: 5px 0;
          margin-top: 8px;
        }
      }
      .show-text {
        padding-top: 12px;
        color: #4089ff;
        font-size: 15px;
        display: flex;
        justify-content: flex-end;
        .time-box {
          height: 24px;
          line-height: 24px;
          text-align: right;
        }
      }
      .time {
        color: #565656;
        font-size: 15px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        display: flex;
        justify-content: flex-start;
        padding-bottom: 8px;
        .time-box {
          height: 24px;
          line-height: 24px;
          text-align: right;
        }
      }
    }
  }
}
</style>
